import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import { RowExportTypePdf } from "types"
import { DataType } from "../hooks"

type UseExportPdf = {
  data: Array<DataType['items'][0]>
}

export const useExportPdf = ({ data, }: UseExportPdf) => {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "PRODUCT STYLE", key: "ps", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 20 },
  ]

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      code: item.mr_product_style_code,
      ps: item.mr_product_style_name,
      description: item.description ?? "",
    }
  })

  return {
    handleExportPdf: () =>
      pdf(
        <PdfTemplate
          data={dataMap}
          column={columns}
        />
      )
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = 'product-style.pdf'
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column,
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>PRODUCT STYLE</Text>
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}>
        </View>
      </Page>
    </Document>
  )
}
